// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IrUI","badges":"styles_badges__8SdoU"};